module.exports = __webpack_public_path__ + "static/media/ladPay.f29b9f04.svg";